// AUTO-GENERATED — DO NOT EDIT THIS FILE DIRECTLY.
//
// Synced from wallet-rbac/RoleContext.jsx
// by scripts/sync_wallet_app.sh on 2026-07-17T08:09:17Z.
//
// To make changes:
//   1. Edit react/_shared/wallet-app/wallet-rbac/RoleContext.jsx
//   2. Run ./scripts/sync_wallet_app.sh
//
// Editing this copy in place will be overwritten on next sync.
//
// ---------------------------------------------------------------

// wallet-rbac/RoleContext.jsx
//
// Customer-side role context. For Track-C apps the default is `signer` —
// every connected wallet can sign for itself. The tenant / team RBAC layer
// ships post-launch; we still expose the hook so app code can be written
// against capabilities today and the multi-role rollout flips behaviour
// without component edits.

import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useAuth } from '../useAuthToken';
import { capabilitiesFor, ROLES, roleHasCapability } from './capabilities';

const RoleContext = createContext({
  role: ROLES.SIGNER,
  setRole: () => {},
  hasCapability: () => false,
  capabilities: [],
});

export function RoleProvider({ initialRole = ROLES.SIGNER, children }) {
  const [role, setRole] = useState(initialRole);
  const auth = useAuth();

  useEffect(() => {
    if (auth?.role && Object.values(ROLES).includes(auth.role)) {
      setRole(auth.role);
    }
  }, [auth?.role]);

  const value = useMemo(
    () => ({
      role,
      setRole,
      hasCapability: (cap) => roleHasCapability(role, cap),
      capabilities: capabilitiesFor(role),
    }),
    [role],
  );

  return <RoleContext.Provider value={value}>{children}</RoleContext.Provider>;
}

export function useRole() {
  return useContext(RoleContext);
}

export default RoleContext;
